import ComponentLayout from '~/src/layouts/component-layout';
import { Box } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  Box,
  React
};